import dayjs from "dayjs";
import { refreshToken } from "../store/actions/login";

export function jwt({ dispatch, getState }: { dispatch: any; getState: any }) {
	return (next: any) => (action: any) => {
		// only worry about expiring token for async actions
		if (typeof action === "function") {
			const { login } = getState();

			const { expiration, token } = login;

			if (token && expiration && dayjs(expiration).diff(dayjs()) < 5000) {
				// make sure we are not already refreshing the token
				if (refreshToken && refreshToken instanceof Function) {
					if (!getState().login.freshTokenPromise) {
						const promise = refreshToken(dispatch, getState);
						if (promise instanceof Promise) {
							return promise.then(() => next(action));
						}
					} else {
						const promise = getState().login.freshTokenPromise;
						if (promise instanceof Promise) {
							return promise.then(() => next(action));
						}
					}
				}
			}
		}
		return next(action);
	};
}
